import { IMemberSearch } from '@/client/legacy-shared-modules/search/search-types';
import { EUserAccountStatus } from '@/client/legacy-shared-modules/user/userEnums';
import type { MemberIndexViewableField } from '@/components/GlobalSearch/types';

import type { SearchAIResults_UsersByIds_usersByIdsForAiAsk_results } from '../../graphql-types/SearchAIResults_UsersByIds';
import { orderRecordsByIds } from '../../utils/contentHelpers';

export function mapUsersByIdsToMemberHits(
  users: SearchAIResults_UsersByIds_usersByIdsForAiAsk_results[],
  orderedUserIds: string[],
  viewableField: MemberIndexViewableField
): IMemberSearch[] {
  return orderRecordsByIds(users, orderedUserIds).map((user) => {
    const viewableAttributes = {
      firstName: user.firstName ?? undefined,
      lastName: user.lastName ?? undefined,
      preferredName: user.preferredName ?? undefined,
      prefix: user.prefix ?? undefined,
      suffix: user.suffix ?? undefined,
      nameTitle: user.nameTitle ?? undefined,
      jobTitle: user.jobTitle ?? undefined,
      company: user.company ?? undefined,
    };

    const memberHit: IMemberSearch = {
      scope: [],
      objectID: user._id,
      userId: user._id,
      displayName: user.displayName,
      profilePictureUrl: user.proxyProfilePictureUrl ?? null,
      accountStatus: EUserAccountStatus.ACTIVE,
      createdAt: new Date(0),
      memberPriority: 0,
      integrationIsMember: true,
      hasAccount: true,
      [viewableField]: viewableAttributes,
    };

    return memberHit;
  });
}
